import TemplateView from "../../../TemplateView";
import {SCOPE_CELL_STATUS} from "./ScopeCell";
import {HierarchyLevels} from "constants";
import CounterWithProgressBar from "../../../components/counterCPT/CounterWithProgressBar";
import {customerNameLower, projectNameLower, taskNameLower} from "../../../util/pluralizeUtils";

export default class ManageCellDetailsBlock extends TemplateView {
    constructor() {
        super();

        this.state = {
            status: SCOPE_CELL_STATUS.ALL,
            nCustomers: 0,
            nProjects: 0,
            nTasks: 0
        }

        this.onStatePropertyChanged('nCustomers', nCustomers =>
            this.updateCounter(this.customersCounter, nCustomers, customerNameLower(nCustomers)))

        this.onStatePropertyChanged('nProjects', nProjects =>
            this.updateCounter(this.projectsCounter, nProjects, projectNameLower(nProjects)))

        this.onStatePropertyChanged('nTasks', nTasks => this.updateCounter(this.tasksCounter, nTasks, taskNameLower(nTasks)))

        this.onStatePropertyChanged('status', () => {
            this.$scopeDetails.toggle(this.state.status === SCOPE_CELL_STATUS.SELECTED)
        })
    }

    templateHtml() {
        return "<div class='cellDetailsBlock'>" +
               "    <div class='scopeDetails'>" +
               "      <div class='counterRow customers'>" +
               "      </div>" +
               "      <div class='counterRow projects'>" +
               "      </div>" +
               "      <div class='counterRow tasks'>" +
               "      </div>" +
               "    </div>" +
               "</div>"
    }

    afterRender() {
        this.$scopeDetails = this.find('.scopeDetails')
        this.customersCounter = new CounterWithProgressBar({
            hierarchyLevel: HierarchyLevels.CUSTOMER,
        }).init(this.find('.counterRow.customers'))
        this.customersCounter.setState({pale: true})

        this.projectsCounter = new CounterWithProgressBar({
            hierarchyLevel: HierarchyLevels.PROJECT,
        }).init(this.find('.counterRow.projects'))
        this.projectsCounter.setState({pale: true})

        this.tasksCounter = new CounterWithProgressBar({
            hierarchyLevel: HierarchyLevels.TASK,
        }).init(this.find('.counterRow.tasks'))
        this.tasksCounter.setState({pale: true})

        this.renderInitialState()
    }

    updateCounter(counter, value, label) {
        counter.setState({
            curValue: value,
            title: label,
        })
    }
}


// WEBPACK FOOTER //
// ./web/js/panels/user/permissions/ManageCellDetailsBlock.js